import { Pipe, PipeTransform } from '@angular/core';
import {UnitAdvertisementDto, UnitTypeDto} from "homey-housing-lottery-app-dto";

@Pipe({
  name: 'filterByUnitType'
})
export class FilterByUnitTypePipe<T extends UnitAdvertisementDto> implements PipeTransform {

  transform(value: T[], unitType: UnitTypeDto): T[] {
    return value.filter(unit => unit.unitType === unitType);
  }
}
